module.exports = __webpack_public_path__ + "images/emoji/radio_button.30dd8798e117fa1fa86c.png";